/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Serve_Faq_1_QInputs */

const en_serve_faq_1_q = /** @type {(inputs: Serve_Faq_1_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is it safe?`)
};

const id_serve_faq_1_q = /** @type {(inputs: Serve_Faq_1_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aman?`)
};

/**
* | output |
* | --- |
* | "Is it safe?" |
*
* @param {Serve_Faq_1_QInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const serve_faq_1_q = /** @type {((inputs?: Serve_Faq_1_QInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Serve_Faq_1_QInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_serve_faq_1_q(inputs)
	return en_serve_faq_1_q(inputs)
});